import { Mars, Venus } from "lucide-react";

export const defaultDarkModeLogo = "/logos/logo-small.png";
export const defaultLightModeLogo = "/logos/logo-small.png";

export const defaultTitle = "Plataforma North";

export const defaultCompanySectors = [
  "Communication Services",
  "Consumer Discretionary",
  "Consumer Staples",
  "Energy",
  "Financials",
  "Health Care",
  "Industrials",
  "Information Technology",
  "Materials",
  "Real Estate",
  "Utilities",
];

/**
 * As nove colunas do CRM da North, na ordem em que o especialista trabalha.
 *
 * A lista veio do Rick e é o funil real da casa: duas tentativas de abordagem
 * (com um delay planejado entre elas), duas de fechamento, e só então a espera
 * pela análise. Ter "abordagem 2" e "fechamento 2" como COLUNAS, e não como
 * anotação dentro de um card, é o ponto: o gerente vê num relance quantos leads
 * estão na segunda tentativa, que é onde a maioria morre em silêncio.
 *
 * Os `value` são o que fica gravado em `deals.stage` e NÃO mudam depois de
 * publicados — a migration 168 traduziu o funil antigo (novo/contatado/
 * qualificado/proposta/fechado/perdido) para estes. Renomear um value aqui sem
 * migration deixa os cards órfãos: `getDealsByStage` só distribui em colunas
 * que existem, então o lead some da tela sem ter sido apagado.
 */
export const defaultDealStages = [
  { value: "novo", label: "Novo lead" },
  { value: "contatado", label: "Contactado" },
  { value: "abordagem", label: "Abordagem" },
  { value: "abordagem_2", label: "Delay / Abordagem 2" },
  { value: "fechamento_1", label: "Fechamento 1" },
  { value: "fechamento_2", label: "Fechamento 2" },
  { value: "em_analise", label: "Em análise" },
  { value: "perdido", label: "Negócio perdido" },
  { value: "ganho", label: "Negócio ganho" },
];

/** Colunas que contam como negócio fechado para o resumo do funil. */
export const defaultDealPipelineStatuses = ["ganho"];

/**
 * Produtos que um lead pode estar comprando. Ordem alfabética porque é uma
 * lista de escolha, não um funil — nada aqui é "depois" de nada.
 */
export const defaultDealCategories = [
  // Não é produto: é o lead de ASSESSORIA (quem quer atuar com a North) que
  // chega pelo /contato — capturado do widget do Bitrix pela edge function
  // lead-site. Separado para não misturar com cliente no kanban.
  "Assessoria",
  "Auto",
  "Consórcio",
  "Investimentos",
  "Plano de Saúde",
  "Residencial",
  "Responsabilidade Civil",
  "Viagem",
  "Vida",
];

export const defaultNoteStatuses = [
  { value: "cold", label: "atomic.contacts.status.cold", color: "#354660" },
  { value: "warm", label: "atomic.contacts.status.warm", color: "#BEB692" },
  { value: "hot", label: "atomic.contacts.status.hot", color: "#0E1619" },
  {
    value: "in-contract",
    label: "atomic.contacts.status.inContract",
    color: "#BCC8C5",
  },
];

export const defaultTaskTypes = [
  "atomic.tasks.types.none",
  "atomic.tasks.types.email",
  "atomic.tasks.types.demo",
  "atomic.tasks.types.lunch",
  "atomic.tasks.types.meeting",
  "atomic.tasks.types.followUp",
  "atomic.tasks.types.thankYou",
  "atomic.tasks.types.ship",
  "atomic.tasks.types.call",
];

export const defaultContactGender = [
  { value: "male", label: "atomic.contacts.gender.male", icon: Mars },
  { value: "female", label: "atomic.contacts.gender.female", icon: Venus },
];
